export const CLASS_NAMES = {
  row: 'items-center justify-start flex flex-row',
  label: 'text-14-22-em w-20 block',
  value: 'text-14-22 block',
};
